export default "__VITE_ASSET__DPN3N$M1__"